import { salesRevenueConstants } from './sales-revenue.constants'

const initialState = {
	isExporting: false,
	downloadData: null
}

function salesRevenueReducer(
	state = initialState,
	{ type, payload: downloadData }
) {
	switch (type) {
		case salesRevenueConstants.EXPORT_DATA:
			return {
				...state,
				isExporting: true
			}

		case salesRevenueConstants.DOWNLOAD_DATA:
			return {
				...state,
				isExporting: false,
				downloadData
			}

		default:
			return state
	}
}

export { salesRevenueReducer as Reducer }
